import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {faPhone,faMessage,faHandFist} from '@fortawesome/free-solid-svg-icons';
import UserInput from "../components/user-input-validations";
import axios from "axios";
import Modal from "./Modal";
const isNotEmpty = (value) => value.trim() !== "" && value.length > 10;
const isEmailValidated = (value) =>
  value.includes("git") || value.trim() !== "";

const Contact = () => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const {
    value: enteredNamesValue,
    isValid: isNamesValid,
    hasError: hasNamesError,
    valueChangeHandler: namesChangeHandler,
    inputBlurHandler: namesInputBlurHandler,
  } = UserInput(isNotEmpty);

  const {
    value: enteredEmailValue,
    isValid: isEmailValid,
    hasError: hasEmailError,
    valueChangeHandler: emailChangeHandler,
    inputBlurHandler: emailInputBlurHandler,
  } = UserInput(isEmailValidated);

  let formIsValid = false;
  if (isEmailValid && isNamesValid) {
    formIsValid = true;
  }

  const enteringNamesClasses = hasNamesError
    ? "min-w-full border-[0.3px] p-2 border-[red] mb-2  outline-none"
    : "min-w-full border-[0.3px] p-2 border-zinc-400 outline-none";

  const enteringEmailClasses = hasEmailError
    ? "min-w-full border-[0.3px] p-2 border-[red] outline-none"
    : "min-w-full border-[0.3px] p-2 border-zinc-400 outline-none";

  const removeStaff = () => {
    setSuccess("");
    document.location.reload();
  };

  const submitHandler = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    if (!formIsValid) {
      return;
    }

    const customerInformations = {
      createdDate: new Date().toISOString(),
      fullnames: enteredNamesValue,
      repository: enteredEmailValue,
    };

    try {
      const response = await axios.post(
        "https://ask-questions-2d083-default-rtdb.firebaseio.com/posts.json",
        customerInformations
      );
      const data = await response.data;
      if (data) {
        setIsLoading(false);
        setSuccess("Successfull done");
      } else {
        setError(data.error);
      }
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };

  return (
    <>
      {success !== "" && (
        <Modal>
          <div className="w-[200px] mx-auto my-0   ">
            <img
              className="w-full h-full"
              src="https://media.istockphoto.com/vectors/check-mark-logo-vector-or-icon-vector-id919118254?k=20&m=919118254&s=612x612&w=0&h=nFTjCeY9bjV1unFsjJvegMvFl68P9JQTcCi9C_Pc5ZE="
              alt=""
            />
          </div>
          <div className="text-center w-full pb-8">{success}</div>
          <button
            onClick={removeStaff}
            className="px-8 py-2 bg-[#FFC43B] text-center w-[100px] mx-auto my-0 ">
            {" "}
            Ok
          </button>
        </Modal>
      )}
      <div className="h-screen">
        <div className="flex flex-col justify-around w-[80%] mx-auto my-0 pt-[5rem] gap-16">
          <div className="w-[70%] text-center mx-auto my-0">
            <div className="font-bold text-2xl pb-4">Question</div>
            <div className="w-[60px] h-[4px] bg-[#FFC43B] text-center my-0 mx-auto "></div>
            <div className="pt-4"></div>
            <div>
              <div className="text-left">
                <div>
                  <div className="pb-4 text-xl">
                    Q1. By Using HTML and CSS try to replicate as possible the
                    following User Interface(UI)
                  </div>
                  <div>
                    <img
                      src="https://cdn.dribbble.com/users/880427/screenshots/16112332/media/1512b3eb04dda6ec4463344edb2ffd10.png"
                      alt="userInterface"
                    />
                  </div>
                  As developer try to guess fonts and colors
                </div>
                <div className="pt-8 ">
                  <div className="pb-4 text-xl">
                    Q2. As array of product to be bought given names of product
                    and price in dollars below try answer all questions Use your
                    favorite programming
                  </div>
                  <div className="font-bold pt-2">
                    {` const item = [ {name: 'Bike', price:100},
                                    {name: 'TV', price:200}, 
                                    {name: 'Album', price:10},
                                    {name: 'Book', price:5},
                                    {name: 'Phone', price:500},
                                    {name: 'Computer', price:1000},
                                    ], `}
                  </div>
                  <div className="pt-2">
                    <div className="py-2 pl-2">
                      1 . Filter and show the product that will be bought when
                      you don't have much money I mean Cheap one
                    </div>
                    <div className="py-2 pl-2">
                      2 . Filter and show the product that will be expensive in
                      the array
                    </div>
                    <div className="py-2 pl-2">
                      3 . Calculate the full price of all product combined
                    </div>
                    <div className="py-2 pl-2">
                      4 . Calculate the full price of all product combined and
                      remove product that are under the 10 dollar
                    </div>
                  </div>
                  <div className="text-center pt-4 font-bold  ">
                    Happy Codding
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-md mx-auto my-0 pt-6">
          <div className="text-left py-4 font-bold text-xl">
            <span className="text-[#000000]">S</span>UBMIT YOUR WORK BELOW
          </div>
          <div className="pb-8">
            <form action="" onSubmit={submitHandler} className="text-left">
              <div className="control-group">
                <div className="pb-4">
                  <label htmlFor="Full Name" className="mb-2">
                    Full names
                  </label>
                  <input
                    className={enteringNamesClasses}
                    type="text"
                    value={enteredNamesValue}
                    onChange={namesChangeHandler}
                    onBlur={namesInputBlurHandler}
                  />
                  {hasNamesError && (
                    <p className="text-[#FFCB33] text-sm">
                      Please Insert full names
                    </p>
                  )}
                </div>

                {/* adding Email */}
                <div className="pb-4">
                  <label htmlFor="Full Name">Github Answers Repository</label>
                  <input
                    className={enteringEmailClasses}
                    type="text"
                    value={enteredEmailValue}
                    onChange={emailChangeHandler}
                    onBlur={emailInputBlurHandler}
                  />
                  {hasEmailError && (
                    <p className="text-[#FFCB33] text-sm">
                      Please Insert valid repository
                    </p>
                  )}
                </div>

                <div className="w-full  text-right">
                  <button
                    disabled={!formIsValid}
                    className="bg-[#FFCB33] text-white px-8 py-2 disabled:bg-slate-300 disabled:cursor-not-allowed">
                    {isLoading ? "Loading..." : " Send Your Answers"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
